module.exports = __webpack_public_path__ + "img/erd.bb83e745.png";